<template>
  <status-chip
    :status="status"
    :statuses="types"
  ></status-chip>
</template>

<script>
import { ref } from '@vue/composition-api'
import StatusChip from '@/components/chips/StatusChip.vue'
import useStatusesList from '@/components/lists/statuses'

export default {
  components: {
    StatusChip,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { statusesList } = useStatusesList()
    const types = ref(statusesList)

    return {
      types,
    }
  },
}
</script>
